var _defs, _rect, _rect2, _rect3, _path, _circle, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 800,
    viewBox: "0 0 600 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 600,
    y2: 800,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EEF6"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 800,
    rx: 28,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 86,
    width: 452,
    height: 628,
    rx: 24,
    fill: "#ffffff",
    stroke: "#D8E0ED",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 156,
    width: 360,
    height: 270,
    rx: 20,
    fill: "#EFF3FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170 390L240 312C253 298 274 298 287 312L335 364L366 333C378 321 397 321 409 333L430 354V426H170V390Z",
    fill: "#CAD6EA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 235,
    r: 34,
    fill: "#CAD6EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 476,
    width: 360,
    height: 24,
    rx: 12,
    fill: "#E8EEF8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 524,
    width: 282,
    height: 18,
    rx: 9,
    fill: "#ECF1F9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 560,
    width: 212,
    height: 18,
    rx: 9,
    fill: "#ECF1F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPlaceholder);
export default __webpack_public_path__ + "static/media/product-placeholder.295021d32e017d03dedc41b77563935f.svg";
export { ForwardRef as ReactComponent };